__turbopack_context__.v({
  "col3": "RK0UUa_col3",
  "inputRows": "RK0UUa_inputRows",
  "leftNoBorder": "RK0UUa_leftNoBorder",
  "noGap": "RK0UUa_noGap",
  "phoneCode": "RK0UUa_phoneCode",
  "root": "RK0UUa_root",
  "row": "RK0UUa_row",
});
